import { Button, List, ListContent, ListDescription, ListHeader, ListItem, Label } from "semantic-ui-react";
import { PermitTypeDocumentType } from "../models/PermitTypeDocumentType";

interface Props {
  permitTypeDocumentTypes?: PermitTypeDocumentType[];
  onSettings: (permitTypeDocumentType: PermitTypeDocumentType) => void;
  onRemove: (permitTypeDocumentType: PermitTypeDocumentType) => void;
}

const PermitTypeDocumentTypesGrid = ({ permitTypeDocumentTypes, onSettings, onRemove }: Props) => {
  const renderDocumentTypeItem = (item: PermitTypeDocumentType) => {
    return (
      <ListItem key={item.id}>
        <ListContent>
          <ListHeader>
            {item.documentType.name}
            {item.settings === null && (
              <Label size="mini" basic style={{ marginLeft: "8px" }}>
                default
              </Label>
            )}
          </ListHeader>
          <ListDescription>
            <Button basic circular style={{ padding: "5px", boxShadow: "0px 0px" }} onClick={() => onSettings(item)}>
              Settings
            </Button>{" "}
            /{" "}
            <Button basic circular style={{ padding: "5px", boxShadow: "0px 0px" }} onClick={() => onRemove(item)}>
              Remove
            </Button>
          </ListDescription>
        </ListContent>
      </ListItem>
    );
  };

  return (
    <List divided relaxed>
      {permitTypeDocumentTypes?.map(renderDocumentTypeItem)}
    </List>
  );
};

export default PermitTypeDocumentTypesGrid;
